<template>
    <c-container>
        <slot />
    </c-container>
</template>
<script setup>
import { CContainer } from '@coreui/vue/dist/esm/components/grid/index.js';
</script>
